<template>
    <div class="lockIndex">
        <topNav :title="title"></topNav>
        <div :class="['carnum-box',{lock:lockStatus == 0}]">
            <div class="carnum">
                <p>{{carNum.slice(0,2)}}<b></b>{{carNum.slice(2)}}</p>
            </div>
            <div class="zz" @click="openWindow(1)">
                <b></b>
            </div>
            <div class="btn" @click="openWindow(0)">点击锁车</div>
        </div>
        <div class="text-content">
            <ul>
                <li><b></b>操作提示</li>
                <li><i></i>锁车解锁需要手机验证</li>
                <li><i></i>解锁前禁止离场</li>
            </ul>
        </div>
        <div class="yzm-window"  v-show="show">
            <div class="container">
                <h2>请输入手机号码进行验证<b @click="closeWindow"></b></h2>
                <div class="from-box">
                    <p class="pnum">
                        <input type="text" v-model="phonenumber" name="" id="" placeholder="请输入手机号码" @blur="scrollRestore">
                    </p>
                    <p class="yzm">
                        <input type="number" v-model="verifycode" placeholder="请输入验证码" maxlength="6" @blur="scrollRestore">
                        <span v-show="!disabledBtn" @click="getAuthCode">获取验证码</span>
                        <span v-show="disabledBtn" class="txt">{{time}}</span>
                    </p>
                </div>
                <div class="confirm-btn" @click="lockCar">{{lockMode == 0?"确认锁车":"确认解锁"}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import topNav from "@/components/topnav/topnav"
import {DETAIL as API} from "@/assets/api"
import {Toast,Dialog} from 'vant';
export default {
    name: 'lockCar',
    components:{
        topNav,

    },
    data() {
        return {
            title:"停车解锁",
            lockStatus:0,
            carNum:"",
            show:false,
            lockMode:0,//0 锁定车辆 1解锁车辆
            phonenumber:"",//
            verifycode:"",//验证码
            id:"",
            time:60,
            myTimer:null,
            disabledBtn:false,//警用获取验证码按钮
        }
    },
    created(){
        this.carNum = this.$route.query.carNum
        this.searchLockStatus(this.carNum)
    },
    mounted(){

    },
    methods:{
        searchLockStatus(carNum){//查询车辆锁定状态
            let originalId = sessionStorage.getItem("originalId");
            let req = {
                carNum,
                originalId,
            }
            this.$http({
                method: 'post',
                url: API.GET_LOCK_STATUS,
                data: req,
                success: function(data){
                    if(data.code == 0){
                        data = data.data;
                        this.lockStatus = data.lock;
                        this.id = data.commid;
                    }else{
                        this.$toast({
                            duration: 1200,
                            message: data.msg
                        });
                    }
                }.bind(this),
                error: function(error){
                    console.log(error)
                }
            })
        },
        openWindow(mode){//打开验证码弹窗
            this.show = true;
            this.lockMode = mode;
            let startTime = sessionStorage.getItem("code_time");
            if(startTime){
                let time = parseInt((new Date().getTime() - startTime)/1000);
                if(time < 60){
                    this.disabledBtn = true;
                    this.time = 60 - time;
                    if(this.myTimer){
                        clearInterval(this.myTimer);
                        this.myTimer = null;
                    }
                    this.myTimer = setInterval(()=>{
                        if(this.time > 0){
                            this.time--;
                        }else{
                            this.time = 60;
                            this.disabledBtn = false;
                            clearInterval(this.myTimer);
                            this.myTimer = null;
                        }
                    },1000);
                }
            }
        },
        scrollRestore(){//页面滚动条复位
            //document.body.scrollTop = 0;
            setTimeout(() => {
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
            }, 100);
        },
        closeWindow(){//关闭验证码弹窗
            this.show = false;
            this.phonenumber = "";
            this.verifycode = "";
        },
        getAuthCode(){//获取验证码
            if(!this.phonenumber){
                this.$dialog.alert({
                    title: '提示',
                    message: '请输入手机号'
                });
                return;
            }
            if(!/^[0-9]{11}$/.test(this.phonenumber)){
                this.$dialog.alert({
                    title: '提示',
                    message: '手机号格式错误'
                });
                return;
            }
            sessionStorage.setItem("code_time",new Date().getTime());
            this.disabledBtn = true;
            if(this.myTimer){
                clearInterval(this.myTimer);
                this.myTimer = null;
            }
            this.myTimer = setInterval(()=>{
                if(this.time > 0){
                    this.time--;
                }else{
                    this.time = 60;
                    this.disabledBtn = false;
                    clearInterval(this.myTimer);
                    this.myTimer = null;
                }
            },1000);
            let originalId = sessionStorage.getItem("originalId");
            let req = {
                phonenumber:this.phonenumber,
                originalId,
                //originalId:"o0b1TwS4YYKnaqay_Adx8xoqxHxo"
            }
            this.$http({
                method: 'post',
                url: API.GET_AUTH_CODE,
                data: this.qs.stringify(req),
                success: function(data){
                    if(data.code == 0){
                        this.$toast({
                            duration: 1200,
                            message:"获取验证码成功"
                        });
                    }else{
                        this.$dialog.alert({
                            title: '提示',
                            message: data.msg
                        });
                    }
                }.bind(this),
                error: function(error){
                    console.log(error)
                }
            })
        },
        lockCar(){//锁定，解锁车辆
            if(!this.verifycode){
                 this.$dialog.alert({
                    title: '提示',
                    message: '验证码不能为空'
                });
                return;
            }
            if(this.verifycode.lenghth <6){
                 this.$dialog.alert({
                    title: '提示',
                    message: '格式错误'
                });  
                return;  
            }
            if(!this.phonenumber){
                 this.$dialog.alert({
                    title: '提示',
                    message: '手机号不能为空'
                });
                return;
            }
            if(!/^[0-9]{11}$/.test(this.phonenumber)){
                this.$dialog.alert({
                    title: '提示',
                    message: '手机号格式错误'
                });
                return;
            }
            let originalId = sessionStorage.getItem("originalId");
            let req = {
                lockmode:this.lockMode,
                id:this.id,
                verifycode:this.verifycode,//验证码
                vehicleno:this.carNum,
                phonenumber:this.phonenumber,
                originalId,
                //originalId:"o0b1TwS4YYKnaqay_Adx8xoqxHxo"
            }
            this.$http({
                method: 'post',
                url: API.LOCK_CAR,
                data: this.qs.stringify(req),
                success: function(data){
                    if(data.code == 0){
                        // data = data.data;
                        // this.lockStatus = data.lock;
                        this.$toast({
                            duration: 1200,
                            message: data.msg
                        });
                        this.closeWindow();
                        this.searchLockStatus(this.carNum);
                    }else{
                        this.$dialog.alert({
                            title: '提示',
                            message: data.msg
                        });
                    }
                }.bind(this),
                error: function(error){
                    console.log(error)
                }
            })
        }
    },
    watch:{
    }


}
</script>
<style>
.lockIndex{
    background: #fff;
}
.lockIndex .carnum-box{
    width: 100%;
    padding: 12px 0;
    margin-top: 15px;
    margin-bottom: 30px;
    position: relative;
}
.lockIndex .carnum-box .btn{
    width: 78px;
    height: 23px;
    background: url("../../../static/images/lock_btn.png");
    background-size: 100% 100%;
    box-sizing: border-box;
    position: absolute;
    top: 25px;
    right: 5%;
    color: rgba(255,255,255,0.8);
    font-size: 10px;
    text-align: left;
    padding-left: 10px;
    line-height: 23px;

}
.lockIndex .carnum-box .carnum{
    height: 92px;
    width: 90%;
    margin: 0 auto;
    background: url("../../../static/images/lock_bg.png");
    background-size: 100% 100%;
}
.lockIndex .carnum-box .zz{
    display: none;
    height: 92px;
    width: 90%;
    background: url("../../../static/images/lock_bg2.png");
    background-size: 100% 100%;
    position: absolute;
    top: 12px;
    left: 5%;
}
.lockIndex .carnum-box.lock .btn{
    display: none;
}
.lockIndex .carnum-box.lock .zz{
    display: block;
}
.lockIndex .carnum-box .zz b{
    top: 50%;
    left: 50%;
    position: absolute;
    width: 25px;
    height: 30px;
    background: url("../../../static/images/lock_tb.png");
    background-size: 100% 100%;
    margin-left: -12px;
    margin-top: -15px;
}
.lockIndex .carnum-box .carnum p{
    line-height: 90px;
    font-size: 24px;
    color: #fff;
}
.lockIndex .carnum-box .carnum p b{
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 8px;
    line-height: 90px;
    background: #fff;
    margin: 0 7px;
    margin-bottom: 4px;
}
.lockIndex .text-content{

}
.lockIndex .text-content li{
    text-align: left;
    font-size: 12px;
    color: #999;
    line-height: 28px;
    padding: 0 5%;
}
.lockIndex .text-content li b{
    float: left;
    width: 17px;
    height: 17px;
       margin-top: 5px;
    margin-left: 0px;
    margin-right: 6px;
    background: url("../../../static/images/lock_msg.png");
    background-size: cover;
}
.lockIndex .text-content li i{
    float: left;
    width: 5px;
    height: 5px;
    background: #999;
    border-radius: 3px;
    margin-top: 11px;
    margin-left: 6px;
    margin-right: 8px;
}
/*验证码弹窗*/
.yzm-window{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.4);
    z-index: 10;
}
.yzm-window .container{
    width: 90%;
    border-radius: 10px;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.yzm-window .container h2{
    text-align: center;
    font-size: 15px;
    color: #333;
    line-height: 60px;
    padding-top: 10px;
}
.yzm-window .container h2 b{
    position: absolute;
    width: 17px;
    height: 17px;
    background:url("../../../static/images/lock_close.svg");
    background-size: 100% 100%;
    top: 10px;
    right: 10px;
}
.yzm-window .container .confirm-btn{
        font-size: 16px;
    color: #4687f8;
    height: 50px;
    text-align: center;
    border-top: 1px solid #e5e5e5;
    line-height: 50px;
}
.yzm-window .container .from-box{
    padding: 0 30px;
    padding-bottom: 25px;
}
.yzm-window .container .from-box p{
    width: 100%;
    box-sizing: border-box;
    padding: 7px 0;
    height: 50px;;
}
.yzm-window .container .from-box p.pnum input{
    width: 100%;
    height: 37px;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    text-align: left;
    line-height: 37px;
    font-size: 12px;
    color: #333;
    text-indent: 10px;
    box-sizing: border-box;
    float: left;
    -webkit-appearance: none;
}
.yzm-window .container .from-box p.yzm input{
    width: 55%;
    height: 37px;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    text-align: left;
    line-height: 37px;
    font-size: 12px;
    color: #333;
    text-indent: 10px;
    box-sizing: border-box;
    float: left;
    -webkit-appearance: none;
}
.yzm-window .container .from-box p.yzm span{
    width: 42%;
    /* margin-left: 3%; */
    height: 37px;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    text-align: center;
    line-height: 37px;
    font-size: 12px;
    color: #4687f8;
    /* display: inline-block; */
    box-sizing: border-box;
    float: right;
}
.yzm-window .container .from-box p.yzm span.txt{
    color: #999;
}
</style>




// WEBPACK FOOTER //
// src/components/lockCar/lockCar.vue